import React from "react";
import { Card, Text } from "@jsq/ds/core";
import { ExistingPaymentPrefDisplayWithId } from "@jsq/payments-components";
import { type GetComplianceCaseQuery } from "~/graphql/supergraphTypes";
import { toGlobalId } from "~/utils/graphql-helpers";

interface Props {
  complianceCase: GetComplianceCaseQuery["complianceCase"] | undefined;
}

const CurrentPaymentInstructions: React.FC<Props> = ({ complianceCase }) => {
  const paymentPrefId = complianceCase?.externalObject?.objectId;
  const hasValidPaymentPrefId =
    typeof paymentPrefId === "string" && paymentPrefId.trim() !== "";

  return (
    <Card>
      <Text marginBottom="lg" variant="strong-md">
        PAYMENT INSTRUCTIONS
      </Text>
      {hasValidPaymentPrefId ? (
        <ExistingPaymentPrefDisplayWithId
          paymentPrefId={toGlobalId("PaymentPrefObjectType", paymentPrefId)}
          displayRevealDetails={true}
          defaultExpanded={true}
          visibleFields={{
            ach: ["bankName", "accountName", "additionalInstructions"],
            wire: ["beneficiaryName", "bank", "wireObi"],
            check: ["payeeName"],
          }}
          showBankDomicile={true}
          isFullWidth={false}
        />
      ) : (
        <Text variant="secondary-md" color="text-error">
          No payment instructions available for this case
        </Text>
      )}
    </Card>
  );
};

export default CurrentPaymentInstructions;
